import React from 'react';
import './BrandLogoSlider.css';

const BrandLogoSlider = () => {
  return (
    <section className="brand-logo-slider-section">
      <div className="brand-logo-slider-container">
        <div className="brand-logo-slider-track">
          {/* First set of logos */}
          <div className="brand-logo-item">
            <img src="/NSE_Logo.jpg" alt="NSE Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/bselogo.png" alt="BSE Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/NISM-Logo.png" alt="NISM Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/iso.png" alt="ISO 9001:2015 Certification" />
          </div>
          <div className="brand-logo-item">
            <div className="company-name">Trillion Stock Research</div>
          </div>
          
          {/* Duplicate set for seamless loop */}
          <div className="brand-logo-item">
            <img src="/NSE_Logo.jpg" alt="NSE Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/bselogo.png" alt="BSE Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/NISM-Logo.png" alt="NISM Logo" />
          </div>
          <div className="brand-logo-item">
            <img src="/iso.png" alt="ISO 9001:2015 Certification" />
          </div>
          <div className="brand-logo-item">
            <div className="company-name">Trillion Stock Research</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogoSlider;
